import { Plugin } from 'prosemirror-state';

import { AddMenuCode, Code } from '@lyearn/icons';
import { EditorOptions } from '@lyearn/lygo-core';

import { addMenuItemType } from '../../../types/menus';
import { addAddMenuBlock } from '../../../utils/menus';
import prism from '../../CodeFence/Prism';
import { NODE_NAME } from '../consts';
import CodeBlock from './CodeBlock';

function plugins({ t, createReactNodeView }: EditorOptions): Plugin[] {
  return [
    prism({
      name: NODE_NAME,
    }),
    new Plugin({
      props: {
        nodeViews: {
          code_block(node, view, getPos, decorations) {
            return createReactNodeView({
              node,
              view,
              getPos,
              decorations,
              component: CodeBlock,
            });
          },
        },
      },
    }),
    new Plugin({
      view: (editorView) => {
        addAddMenuBlock(editorView, [
          {
            name: NODE_NAME,
            title: t('Lygo:Menu.code_block.title') as string,
            description: t('Lygo:Menu.code_block.description') as string,
            icon: Code,
            addMenuIcon: AddMenuCode,
            addMenuItemType: addMenuItemType.basic_blocks,
            searchWords: ['code', 'text', 'snippet', 'basic'],
            isText: true,
          },
        ]);
        return {};
      },
    }),
  ];
}

export default plugins;
